import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../Components/AuthLayout';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useDispatch, useSelector } from 'react-redux';
import { signup, clearAuthError } from '../redux/actions/authActions';

// const inputStyle = {
//   background: '#fff',
//   borderRadius: 4,
//   fontSize: 15,
//   color: '#111',
// };
// const inputSx = {
//   '& .MuiInputBase-root': {
//     backgroundColor: '#fff',
//   },
//   '& .MuiInputBase-root.Mui-focused': {
//     backgroundColor: '#fff',
//   },
//   '& .MuiInputBase-root:hover': {
//     backgroundColor: '#fff',
//   },
//   '& .MuiInputBase-root.Mui-disabled': {
//     backgroundColor: '#f5f5f5',
//   },
//   '& .MuiInputBase-input': {
//     backgroundColor: '#fff',
//   },
//   '& .MuiOutlinedInput-notchedOutline': {
//     borderColor: '#bdbdbd',
//   },
//   '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
//     borderColor: '#111',
//   },
// };

function Register() {
  const { register, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [apiError, setApiError] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(clearAuthError());
    setApiError('');
    if (localStorage.getItem('user')) {
      navigate('/dashboard');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, dispatch]);

  useEffect(() => {
    setApiError(error || '');
  }, [error]);

  // Partner ID helpers: mask as 000-000-0000 while typing, store masked in form
  const formatPartnerId = (raw) => {
    const digits = String(raw || '').replace(/\D/g, '').slice(0, 10);
    const part1 = digits.slice(0, 3);
    const part2 = digits.slice(3, 6);
    const part3 = digits.slice(6, 10);
    if (digits.length <= 3) return part1;
    if (digits.length <= 6) return `${part1}-${part2}`;
    return `${part1}-${part2}-${part3}`;
  };

  const normalizeShopifyUrl = (value) => {
    try {
      const trimmed = String(value || '').trim();
      if (!trimmed) return '';
      const withProtocol = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
      const url = new URL(withProtocol);
      const host = url.hostname.toLowerCase();
      if (!host.endsWith('.myshopify.com')) return '';
      const subdomain = host.replace('.myshopify.com', '');
      if (!/^[a-z0-9-]+$/i.test(subdomain)) return '';
      return `${subdomain}.myshopify.com`;
    } catch {
      return '';
    }
  };

  const onSubmit = async (data) => {
    try {
      const normalizedStore = normalizeShopifyUrl(data.storeUrl);
      const partner_id = String(data.partnerId || '').replace(/\D/g, '');
      await dispatch(signup(data.company, data.email, data.password, normalizedStore, partner_id));
      reset();
      dispatch(clearAuthError());
      navigate('/login');
    } catch (e) {}
  };
  const password = watch('password');

  const handleNavigate = (path) => {
    reset();
    dispatch(clearAuthError());
    setApiError('');
    navigate(path);
  };

  return (
    <AuthLayout>
      <h2 style={{ fontWeight: 800, marginBottom: 22, textAlign: 'left', fontFamily: 'Inter, sans-serif', color: '#e2e8f0' }}>Create an account</h2>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div style={{ marginBottom: 14 }}>
                         <TextField
               label="Brand Name"
               placeholder="Enter your brand name"
               type="text"
               fullWidth
               variant="outlined"
               size="small"
               InputProps={{ style: { background: 'transparent', color: '#e2e8f0' } }}
               sx={{
                 '& .MuiOutlinedInput-root fieldset': { borderColor: '#334155' },
                 '& .MuiOutlinedInput-root:hover fieldset': { borderColor: '#64748b' },
                 '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: '#ffffff' },
                 '& .MuiInputBase-input': { color: '#e2e8f0' },
                 '& .MuiInputLabel-root': { color: '#e2e8f0' },
                 '& .MuiInputLabel-root.Mui-focused': { color: '#ffffff' },
                 '& .MuiInputLabel-root.MuiInputLabel-shrink': { color: '#e2e8f0' },
                 '& input:-webkit-autofill': {
                   WebkitBoxShadow: '0 0 0 1000px #1d283a inset',
                   WebkitTextFillColor: '#e2e8f0',
                   caretColor: '#e2e8f0',
                 },
               }}
               {...register('company', { 
                 required: 'Brand Name is required',
                 minLength: { value: 2, message: 'Brand name must be at least 2 characters' }
               })}
               error={!!errors.company}
               helperText={errors.company ? errors.company.message : ''}
             />
          </div>
          <div style={{ marginBottom: 14 }}>
            <TextField
              label="Store URL"
              placeholder="yourstore.myshopify.com"
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{ style: { background: 'transparent', color: '#e2e8f0' } }}
              sx={{
                '& .MuiOutlinedInput-root fieldset': { borderColor: '#334155' },
                '& .MuiOutlinedInput-root:hover fieldset': { borderColor: '#64748b' },
                '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: '#ffffff' },
                '& .MuiInputBase-input': { color: '#e2e8f0' },
                '& .MuiInputLabel-root': { color: '#e2e8f0' },
                '& .MuiInputLabel-root.Mui-focused': { color: '#ffffff' },
                '& .MuiInputLabel-root.MuiInputLabel-shrink': { color: '#e2e8f0' },
                '& input:-webkit-autofill': {
                  WebkitBoxShadow: '0 0 0 1000px #1d283a inset',
                  WebkitTextFillColor: '#e2e8f0',
                  caretColor: '#e2e8f0',
                },
              }}
              {...register('storeUrl', {
                required: 'Store URL is required',
                validate: (value) => !!normalizeShopifyUrl(value) || 'Enter a valid Shopify URL (*.myshopify.com)'
              })}
              error={!!errors.storeUrl}
              helperText={errors.storeUrl ? errors.storeUrl.message : ''}
              onBlur={(e) => {
                const normalized = normalizeShopifyUrl(e.target.value);
                if (normalized) setValue('storeUrl', `https://${normalized}`);
              }}
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <TextField
              label="Agency Code (if any)"
              placeholder="000-000-0000"
              type="text"
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{ style: { background: 'transparent', color: '#e2e8f0' } }}
              sx={{
                '& .MuiOutlinedInput-root fieldset': { borderColor: '#334155' },
                '& .MuiOutlinedInput-root:hover fieldset': { borderColor: '#64748b' },
                '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: '#ffffff' },
                '& .MuiInputBase-input': { color: '#e2e8f0' },
                '& .MuiInputLabel-root': { color: '#e2e8f0' },
                '& .MuiInputLabel-root.Mui-focused': { color: '#ffffff' },
                '& .MuiInputLabel-root.MuiInputLabel-shrink': { color: '#e2e8f0' },
              }}
              {...register('partnerId', {
                pattern: { value: /^\d{3}-\d{3}-\d{4}$/, message: 'Format must be 000-000-0000' },
                onChange: (e) => {
                  const masked = formatPartnerId(e.target.value);
                  setValue('partnerId', masked, { shouldValidate: true });
                }
              })}
              error={!!errors.partnerId}
              helperText={errors.partnerId ? errors.partnerId.message : ''}
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <TextField
              label="Email"
              type="email"
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{ style: { background: 'transparent', color: '#e2e8f0' } }}
              sx={{
                '& .MuiOutlinedInput-root fieldset': { borderColor: '#334155' },
                '& .MuiOutlinedInput-root:hover fieldset': { borderColor: '#64748b' },
                '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: '#ffffff' },
                '& .MuiInputBase-input': { color: '#e2e8f0' },
                '& .MuiInputLabel-root': { color: '#e2e8f0' },
                '& .MuiInputLabel-root.Mui-focused': { color: '#ffffff' },
                '& .MuiInputLabel-root.MuiInputLabel-shrink': { color: '#e2e8f0' },
                '& input:-webkit-autofill': {
                  WebkitBoxShadow: '0 0 0 1000px #1d283a inset',
                  WebkitTextFillColor: '#e2e8f0',
                  caretColor: '#e2e8f0',
                },
              }}
              {...register('email', { required: 'Email is required' })}
              error={!!errors.email}
              helperText={errors.email ? errors.email.message : ''}
            />
          </div>
          <div style={{ marginBottom: 14 }}>
            <TextField
              label="Password"
              type={showPassword ? 'text' : 'password'}
              fullWidth
              variant="outlined"
              size="small"
               InputProps={{
                style: { background: 'transparent', color: '#e2e8f0' },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword((show) => !show)} edge="end" size="small" sx={{ color: '#ffffff' }}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root fieldset': { borderColor: '#334155' },
                '& .MuiOutlinedInput-root:hover fieldset': { borderColor: '#64748b' },
                '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: '#ffffff' },
                '& .MuiInputBase-input': { color: '#e2e8f0' },
                '& .MuiInputLabel-root': { color: '#e2e8f0' },
                '& .MuiInputLabel-root.Mui-focused': { color: '#ffffff' },
                '& .MuiInputLabel-root.MuiInputLabel-shrink': { color: '#e2e8f0' },
                '& input:-webkit-autofill': {
                  WebkitBoxShadow: '0 0 0 1000px #1d283a inset',
                  WebkitTextFillColor: '#e2e8f0',
                  caretColor: '#e2e8f0',
                },
              }}
              {...register('password', { required: 'Password is required', minLength: { value: 6, message: 'Password must be at least 6 characters long' } })}
              error={!!errors.password}
              helperText={errors.password ? errors.password.message : ''}
            />
          </div>
          <div style={{ marginBottom: 20 }}>
            <TextField
              label="Confirm Password"
              type={showConfirm ? 'text' : 'password'}
              fullWidth
              variant="outlined"
              size="small"
               InputProps={{
                style: { background: 'transparent', color: '#e2e8f0' },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowConfirm((show) => !show)} edge="end" size="small" sx={{ color: '#ffffff' }}>
                      {showConfirm ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root fieldset': { borderColor: '#334155' },
                '& .MuiOutlinedInput-root:hover fieldset': { borderColor: '#64748b' },
                '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: '#ffffff' },
                '& .MuiInputBase-input': { color: '#e2e8f0' },
                '& .MuiInputLabel-root': { color: '#e2e8f0' },
                '& .MuiInputLabel-root.Mui-focused': { color: '#ffffff' },
                '& .MuiInputLabel-root.MuiInputLabel-shrink': { color: '#e2e8f0' },
                '& input:-webkit-autofill': {
                  WebkitBoxShadow: '0 0 0 1000px #1d283a inset',
                  WebkitTextFillColor: '#e2e8f0',
                  caretColor: '#e2e8f0',
                },
              }}
              {...register('confirmPassword', {
                required: 'Confirm Password is required',
                validate: value => value === password || 'Passwords do not match',
              })}
              error={!!errors.confirmPassword}
              helperText={errors.confirmPassword ? errors.confirmPassword.message : ''}
            />
          </div>
          <Button
            type="submit"
            fullWidth
            disabled={loading}
            variant="contained"
            sx={{ background: '#2563eb', color: '#fff', fontWeight: 700, fontSize: 16, mb: 1, borderRadius: 2, py: 1, '&:hover': { background: '#1e40af' } }}
          >
            {loading ? 'Creating...' : 'Register'}
          </Button>
          {apiError && (
            <div style={{
              background: '#fdecea',
              color: '#b71c1c',
              border: '1px solid #f5c6cb',
              borderRadius: 8,
              padding: '10px 12px',
              textAlign: 'center',
              fontWeight: 600,
              marginTop: 10,
            }}>
              {apiError}
            </div>
          )}
      </form>
      <div style={{ textAlign: 'center', marginTop: 12 }}>
        <button type="button" onClick={()=>handleNavigate('/login')} style={{ background: 'none', border: 'none', padding: 0, color: '#94a3b8', fontWeight: 500, textDecoration: 'none', cursor: 'pointer' }}>Already have an account? Login</button>
      </div>
    </AuthLayout>
  );
}

export default Register;
